<div class="transport-form-container">
  <form nz-form [formGroup]="form" [nzLayout]="'vertical'">

    <div class="form-section">
      <!-- <div class="section-header">
        <h3 class="section-title">Transport Requirements</h3>
      </div> -->

      <nz-form-item>
        <nz-form-label>Airport Transfers</nz-form-label>
        <nz-form-control>
          <nz-select nzMode="multiple" nzShowSearch nzAllowClear formControlName="airport_transfers"
            nzPlaceHolder="Select airport transfers">
            <nz-option *ngFor="let v of airportTransfersResponseModel.value.results" [nzValue]="v.id"
              [nzLabel]="v.name">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Local/Venue Transfers</nz-form-label>
        <nz-form-control>
          <nz-select nzMode="multiple" nzShowSearch nzAllowClear formControlName="local_venue_transfers"
            nzPlaceHolder="Select local/venue transfers">
            <nz-option *ngFor="let v of localVenueTransfersResponseModel.value.results" [nzValue]="v.id"
              [nzLabel]="v.name">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Vehicle Types</nz-form-label>
        <nz-form-control>
          <nz-select nzMode="multiple" nzShowSearch nzAllowClear formControlName="vehicles_types"
            nzPlaceHolder="Select vehicle types">
            <nz-option *ngFor="let v of vehiclesTypesResponseModel.value.results" [nzValue]="v.id" [nzLabel]="v.name">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control>
          <button nz-button nzType="primary" (click)="onSave()" [disabled]="form.invalid">
            Submit
          </button>
        </nz-form-control>
      </nz-form-item>
    </div>

  </form>
</div>